import React, { Component, type JSX } from 'react';

interface ComponentProps {
  error: string;
}

/**
 * Render the error message returned by the backend for bijles.
 */
export class SearchBijlesNotFound extends Component<ComponentProps> {

  public render(): JSX.Element {
    const { error } = this.props;

    return (
      <div className="container">
        <div className="search-filter__error__bl">
          <div><p>{error}</p><p>Direct aan de slag en snel resultaat, ook in de schoolvakanties!</p></div>
          <div><a href="/online-bijles/">Meer informatie of direct aanmelden</a></div>
        </div>
      </div>
    );
  }
}

/**
 * Render the error message returned by the backend for Huiswerkbegeleiding.
 */
export class SearchHWBNotFound extends Component<ComponentProps> {

  public render(): JSX.Element {
    const { error } = this.props;

    return (
      <div className="container">
        <div className="search-filter__error">
          <strong>{error}</strong>
        </div>
      </div>
    );
  }
}

/**
 * Render the error message returned by the backend for basisschool begeleiding.
 */
export class SearchBLNotFound extends Component<ComponentProps> {

  public render(): JSX.Element {
    const { error } = this.props;

    return (
      <div className="container">
        <div className="search-filter__error">
          <strong>{error}</strong>
        </div>
      </div>
    );
  }
}
